import { FC } from 'react';
import { Center } from '@chakra-ui/react';

export const Home: FC = () => (
  <Center w="full">Welcome to crossbuildz Home</Center>
);
